
document.addEventListener('DOMContentLoaded', function() {
  // Desktop logic
  var gallerySection = document.getElementById('gtu-page-gallary-video-list-section-container-desktop');
  var mainSection = document.getElementById('gtu-page-videos-main-section-desktop');
  var detailSection = document.getElementById('gtu-page-video-list-data-page');
  var newsBreadcrumb = document.getElementById('gtu-news-breadcrumb');

  // Hide detail section by default
  if (detailSection) detailSection.style.display = 'none';

  // Click on desktop article card → navigate to article
  var videoItems = [];
  if (gallerySection) {
    videoItems = gallerySection.querySelectorAll('.gtu-page-gallary-video-item-image-container');
  } else {
    videoItems = document.querySelectorAll('.gtu-page-gallary-video-item-image-container');
  }
  videoItems.forEach(function(item) {
    item.addEventListener('click', function() {
      var postUrl = item.getAttribute('data-post-url');
      if (postUrl) window.location.href = postUrl;
    });
  });

  // News breadcrumb back button (desktop)
  if (newsBreadcrumb) {
    newsBreadcrumb.addEventListener('click', function() {
      if (gallerySection) gallerySection.style.display = 'block';
      if (mainSection) mainSection.style.display = 'flex';
      if (detailSection) detailSection.style.display = 'none';
    });
  }

  // Filter modal open/close (desktop)
  var filterBtn = document.getElementById('filter-button-desktop');
  var filterModal = document.getElementById('gtu-gallery-video-filter-desktop');
  var filterCloseBtn = filterModal ? filterModal.querySelector('.gtu-gallery-video-filter-close') : null;

  if (filterBtn && filterModal) {
    filterBtn.addEventListener('click', function() { filterModal.style.display = 'block'; });
  }
  if (filterCloseBtn && filterModal) {
    filterCloseBtn.addEventListener('click', function() { filterModal.style.display = 'none'; });
  }
  if (filterModal) {
    filterModal.addEventListener('click', function(e) {
      if (e.target === filterModal) filterModal.style.display = 'none';
    });
  }

  // Click on mobile article card → navigate to article
  var mobileGalleryItems = document.querySelectorAll(
    '.gtu-page-gallary-video-item-metaobjec-container .gtu-page-gallary-video-item-image-container-mobile'
  );
  mobileGalleryItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
      var postUrl = item.getAttribute('data-post-url');
      if (postUrl) window.location.href = postUrl;
    });
  });

  // Filter modal open/close (mobile)
  var filterBtnMobile = document.getElementById('filter-button-mobile');
  var filterModalMobile = document.getElementById('gtu-gallery-video-filter-mobile');
  var filterCloseMobile = filterModalMobile ? filterModalMobile.querySelector('.gtu-gallery-video-filter-close-mobile') : null;

  if (filterBtnMobile && filterModalMobile) {
    filterBtnMobile.addEventListener('click', function(e) {
      e.preventDefault();
      filterModalMobile.style.display = 'block';
    });
  }
  if (filterCloseMobile && filterModalMobile) {
    filterCloseMobile.addEventListener('click', function() { filterModalMobile.style.display = 'none'; });
  }
  if (filterModalMobile) {
    filterModalMobile.addEventListener('click', function(e) {
      if (e.target === filterModalMobile) filterModalMobile.style.display = 'none';
    });
  }

  // Escape key closes modals
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (filterModal && filterModal.style.display === 'block') filterModal.style.display = 'none';
      if (filterModalMobile && filterModalMobile.style.display === 'block') filterModalMobile.style.display = 'none';
    }
  });

  // ===== NEWS FILTER LOGIC =====

  // Desktop filter elements
  var wheelSelectDesktop = document.querySelector('[data-news-filter-wheel-desktop]');
  var tagSelectDesktop = document.querySelector('[data-news-filter-tag-desktop]');
  var applyFilterDesktop = document.querySelector('[data-news-apply-filter-desktop]');
  var clearFilterDesktop = document.querySelector('[data-news-clear-filter-desktop]');
  var keywordInputDesktop = document.querySelector('[data-news-keyword-desktop]');
  var searchBtnDesktop = document.querySelector('[data-news-search-desktop]');
  var desktopContainer = document.querySelector('[data-gtu-video-gallery-desktop]');
  var desktopCountEl = document.querySelector('.gtu-page-gallary-title-container-digit-desktop');

  // Mobile filter elements
  var wheelSelectMobile = document.querySelector('[data-news-filter-wheel-mobile]');
  var tagSelectMobile = document.querySelector('[data-news-filter-tag-mobile]');
  var applyFilterMobile = document.querySelector('[data-news-apply-filter-mobile]');
  var clearFilterMobile = document.querySelector('[data-news-clear-filter-mobile]');
  var keywordInputMobile = document.querySelector('[data-news-keyword-mobile]');
  var searchBtnMobile = document.querySelector('[data-news-search-mobile]');
  var mobileContainer = document.querySelector('[data-gtu-video-gallery-mobile]');
  var mobileCountEl = document.querySelector('.gtu-page-gallary-title-container-digit');

  // Filter button active state (red when any filter is selected)
  function checkActiveDesktop() {
    if (!applyFilterDesktop) return;
    var hasWheel = wheelSelectDesktop && wheelSelectDesktop.value !== '';
    var hasTag = tagSelectDesktop && tagSelectDesktop.value !== '';
    if (hasWheel || hasTag) {
      applyFilterDesktop.classList.add('gtu-filter-button-active');
    } else {
      applyFilterDesktop.classList.remove('gtu-filter-button-active');
    }
  }
  function checkActiveMobile() {
    if (!applyFilterMobile) return;
    var hasWheel = wheelSelectMobile && wheelSelectMobile.value !== '';
    var hasTag = tagSelectMobile && tagSelectMobile.value !== '';
    if (hasWheel || hasTag) {
      applyFilterMobile.classList.add('gtu-filter-button-active');
    } else {
      applyFilterMobile.classList.remove('gtu-filter-button-active');
    }
  }
  if (wheelSelectDesktop) wheelSelectDesktop.addEventListener('change', checkActiveDesktop);
  if (tagSelectDesktop) tagSelectDesktop.addEventListener('change', checkActiveDesktop);
  if (wheelSelectMobile) wheelSelectMobile.addEventListener('change', checkActiveMobile);
  if (tagSelectMobile) tagSelectMobile.addEventListener('change', checkActiveMobile);

  // Filter function for news — supports wheel, tag, and keyword
  function filterNews(container, countEl, wheelValue, tagValue, keyword) {
    if (!container) return;
    var items = container.querySelectorAll('[data-title]');
    var visibleCount = 0;

    items.forEach(function(item) {
      var title = (item.getAttribute('data-title') || '').toLowerCase();
      var tags = (item.getAttribute('data-tags') || '').toLowerCase();
      var featuredProduct = (item.getAttribute('data-featured-product') || '').toLowerCase();
      var show = true;

      if (wheelValue && featuredProduct.indexOf(wheelValue.toLowerCase()) === -1) {
        show = false;
      }
      if (tagValue && tags.indexOf(tagValue.toLowerCase()) === -1) {
        show = false;
      }
      if (keyword && title.indexOf(keyword.toLowerCase()) === -1) {
        show = false;
      }

      // Show/hide the item
      item.style.display = show ? '' : 'none';
      // For mobile, also hide sibling elements (title + read more link)
      var next = item.nextElementSibling;
      while (next && !next.hasAttribute('data-title') && !next.classList.contains('gtu-page-gallary-video-item-image-container-mobile')) {
        next.style.display = show ? '' : 'none';
        next = next.nextElementSibling;
      }

      if (show) visibleCount++;
    });

    if (countEl) countEl.textContent = visibleCount;
  }

  function resetNews(wheelSelect, tagSelect, keywordInput, container, countEl, applyBtn) {
    if (wheelSelect) wheelSelect.value = '';
    if (tagSelect) tagSelect.value = '';
    if (keywordInput) keywordInput.value = '';
    if (applyBtn) applyBtn.classList.remove('gtu-filter-button-active');
    if (container) {
      var items = container.querySelectorAll('[data-title]');
      items.forEach(function(item) {
        item.style.display = '';
        var next = item.nextElementSibling;
        while (next && !next.hasAttribute('data-title') && !next.classList.contains('gtu-page-gallary-video-item-image-container-mobile')) {
          next.style.display = '';
          next = next.nextElementSibling;
        }
      });
      if (countEl) countEl.textContent = items.length;
    }
  }

  // Desktop: Apply Filter
  if (applyFilterDesktop) {
    applyFilterDesktop.addEventListener('click', function() {
      var wheel = wheelSelectDesktop ? wheelSelectDesktop.value : '';
      var tag = tagSelectDesktop ? tagSelectDesktop.value : '';
      filterNews(desktopContainer, desktopCountEl, wheel, tag, '');
      if (filterModal) filterModal.style.display = 'none';
    });
  }

  // Desktop: Clear Filter
  if (clearFilterDesktop) {
    clearFilterDesktop.addEventListener('click', function() {
      resetNews(wheelSelectDesktop, tagSelectDesktop, keywordInputDesktop, desktopContainer, desktopCountEl, applyFilterDesktop);
      if (filterModal) filterModal.style.display = 'none';
    });
  }

  // Desktop: Keyword Search
  if (searchBtnDesktop) {
    searchBtnDesktop.addEventListener('click', function() {
      var keyword = keywordInputDesktop ? keywordInputDesktop.value : '';
      filterNews(desktopContainer, desktopCountEl, '', '', keyword);
      if (filterModal) filterModal.style.display = 'none';
    });
  }
  if (keywordInputDesktop) {
    keywordInputDesktop.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        filterNews(desktopContainer, desktopCountEl, '', '', keywordInputDesktop.value);
        if (filterModal) filterModal.style.display = 'none';
      }
    });
  }

  // Mobile: Apply Filter
  if (applyFilterMobile) {
    applyFilterMobile.addEventListener('click', function() {
      var wheel = wheelSelectMobile ? wheelSelectMobile.value : '';
      var tag = tagSelectMobile ? tagSelectMobile.value : '';
      filterNews(mobileContainer, mobileCountEl, wheel, tag, '');
      if (filterModalMobile) filterModalMobile.style.display = 'none';
    });
  }

  // Mobile: Clear Filter
  if (clearFilterMobile) {
    clearFilterMobile.addEventListener('click', function() {
      resetNews(wheelSelectMobile, tagSelectMobile, keywordInputMobile, mobileContainer, mobileCountEl, applyFilterMobile);
      if (filterModalMobile) filterModalMobile.style.display = 'none';
    });
  }

  // Mobile: Keyword Search
  if (searchBtnMobile) {
    searchBtnMobile.addEventListener('click', function() {
      var keyword = keywordInputMobile ? keywordInputMobile.value : '';
      filterNews(mobileContainer, mobileCountEl, '', '', keyword);
      if (filterModalMobile) filterModalMobile.style.display = 'none';
    });
  }
  if (keywordInputMobile) {
    keywordInputMobile.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        filterNews(mobileContainer, mobileCountEl, '', '', keywordInputMobile.value);
        if (filterModalMobile) filterModalMobile.style.display = 'none';
      }
    });
  }
});
